export default {
  room: [],
  roomID: 0,
  schichtOptions: [
    { text: "früh", value: "1", color: 'warning', selected: true},
    { text: "spät", value: "2", color: 'success' },
    { text: "nacht", value: "3", color: 'info' }
  ]
}
